<script>
  import { Subscriber, collections, asteroid } from "@/meteor.js";
  export let codes;
  const { products } = collections;

  $: last100codes = codes.slice(-100)

  $: uniqueCodes = codes.reduce((total, value, _index, arr) => {
    const index = total.findIndex(v => v.code === value.code);


    if (index === -1) total.push({ ...value, freq: 1 });
    else {
      total[index].freq = total[index].freq + 1;
      total[index].pct = total[index].freq / arr.length * 100
    }
    return total;
  }, []);

  $: sortedCodes = uniqueCodes.sort((code1, code2) => code1.freq > code2.freq ? -1 : 1)

  $: uniqueCodesWithProducts = sortedCodes.map(code => {
    code.product = Object.values($products).filter(
      product => product.EANCode == code.code
    )[0];
    return code;
  });

  const subscribe = Subscriber();
  $subscribe;
  $: codes &&
    subscribe.setQuery("products", {
      EANCode: { $in: uniqueCodes.map(code => code.code) }
    });

  async function createProduct(EANCode) {
    const id = await asteroid.call("products.insert", {
      EANCode,
      ItemNumber: "typo" + Date.now()
    });
    history.pushState({}, "", "/products/" + id);
  }
</script>

<div class="result">
  {#each uniqueCodesWithProducts as result, index}
    {#if result.freq > 5 && result.pct > 20}
      <span>
        {#if result.product}
          <a
            class="btn outline green mt-2 mr-2"
            href={'/products/' + result.product._id}>
            {result.product.ItemText1 || ''} <small> ({result.code})</small>
          </a>
        {:else}
          <button
            on:click={() => createProduct(result.code)}
            class="btn outline orange mt-2 mr-2">
            {result.code} [Opret produkt]
          </button>
        {/if}
      </span>
    {/if}
  {/each}
  {#if uniqueCodesWithProducts.length}
  <button class="btn outline gray">nulstil</button>
  {/if}
</div>
